import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "choice-field-content" }
const _hoisted_4 = ["value", "onKeydown"]
const _hoisted_5 = ["value", "onKeydown"]
const _hoisted_6 = {
  key: 0,
  class: "choice-list"
}
const _hoisted_7 = ["value", "textContent", "onClick"]

import { computed, onMounted, PropType, ref, watch } from "vue";
import { fieldProps } from "./field.composable";

export interface Item {
  label: string;
  value: string | any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldChoice',
  props: {
  ...fieldProps,
  modelValue: {
    required: true
  },
  items: {
    type: Array as PropType<Item[]>,
    required: true
  }
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const item = ref<any>(
  props.items.find((v) => v.value === props.modelValue) || null
);

watch(
  props,
  () => {
    item.value = props.items.find((v) => v.value === props.modelValue) || null;
  },
  { deep: true }
);

const open = ref<boolean>(false);
const focussed = ref<number>(0);

const openClass = computed<string>(() =>
  open.value ? "choice-input-open" : ""
);

const setItem = () => {
  item.value = props.items.find((i) => i.value === props.modelValue);
};

const update = () => {
  emit("update:modelValue", item.value.value);
};

const toggleList = () => {
  open.value = !open.value;
  focussed.value =
    open.value && item.value
      ? props.items.findIndex((i) => i.value === item.value.value)
      : -1;
};

const close = () => {
  open.value = false;
};

const blur = () => {
  // prevent the blur from closing before a choose function has had time to work
  setTimeout(() => close(), 250);
};

const choose = () => {
  if (open.value) {
    chooseItem(focussed.value);
  }
};

const chooseItem = (index: number) => {
  const i = props.items[index];
  item.value = i;
  update();
  close();
};

const focusClass = (index: number) => {
  return index === focussed.value ? "choice-focus" : "";
};

const next = () => {
  if (!open.value) {
    toggleList();
    return;
  }
  focussed.value++;
  if (focussed.value > props.items.length - 1) {
    focussed.value = 0;
  }
};

const previous = () => {
  focussed.value--;
  if (focussed.value < 0) {
    focussed.value = props.items.length - 1;
  }
};

onMounted(() => {
  setItem();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('field choice-input ' + openClass.value)
  }, [
    (!props.hideLabel)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (
          props.validation &&
          props.validation.$invalid &&
          !props.validation.$dirty
        )
            ? (_openBlock(), _createElementBlock("sup", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        class: "visible",
        type: "text",
        readonly: "",
        value: item.value ? item.value.label : '',
        onClick: toggleList,
        onKeydown: [
          _withKeys(_withModifiers(close, ["prevent"]), ["esc"]),
          _withKeys(_withModifiers(choose, ["prevent"]), ["enter"]),
          _withKeys(_withModifiers(previous, ["prevent"]), ["up"]),
          _withKeys(_withModifiers(next, ["prevent"]), ["down"])
        ]
      }, null, 40, _hoisted_4),
      _createElementVNode("input", {
        class: "invisible",
        type: "text",
        tabindex: "-1",
        readonly: "",
        value: item.value,
        onBlur: _withModifiers(blur, ["prevent"]),
        onClick: toggleList,
        onKeydown: [
          _withKeys(_withModifiers(close, ["prevent"]), ["esc"]),
          _withKeys(_withModifiers(choose, ["prevent"]), ["space"]),
          _withKeys(_withModifiers(choose, ["prevent"]), ["enter"]),
          _withKeys(_withModifiers(previous, ["prevent"]), ["up"]),
          _withKeys(_withModifiers(next, ["prevent"]), ["down"])
        ]
      }, null, 40, _hoisted_5),
      (open.value)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(focusClass(index)),
                value: item.value,
                textContent: _toDisplayString(item.label),
                key: item.label,
                onClick: _withModifiers(($event: any) => (chooseItem(index)), ["stop","prevent"])
              }, null, 10, _hoisted_7))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})